<div class="flex fx-column full-wh-percent">
  <div class="full-w-percent flex fx-column ion-justify-content-start" [style.height]="'5%'">
    <ion-toolbar color="primary">
      <ion-title id="modal-title" class="ion-text-center ion-no-padding ion-text-uppercase fs-pt-16">
        {{'SELEZIONA EVENTO'}}
      </ion-title>
    </ion-toolbar>
  </div>

  <div class="full-w-percent flex fx-column ion-justify-content-start" [style.height]="'10%'">
    <ion-segment [value]="currentSegment" (ionChange)="segmentVisualizationChanged($event)"
      class="ion-padding">
      <ion-segment-button [value]="visualizzazione.PASTA_IN_BIANCO">
        <ion-label>{{visualizzazione.PASTA_IN_BIANCO | uppercase}}</ion-label>
      </ion-segment-button>
      <ion-segment-button [value]="visualizzazione.ASSENZA_STUDENTE">
        <ion-label>{{visualizzazione.ASSENZA_STUDENTE | uppercase}}</ion-label>
      </ion-segment-button>
    </ion-segment>
  </div>

  <!---------- MARK: PASTA IN BIANCO --------------->
  @if (currentSegment === visualizzazione.PASTA_IN_BIANCO) {
    <div [style.height]="'85%'"
      class="flex fx-column ion-justify-content-between ion-padding full-w-percent">
      <div class="ion-padding ion-text-center full-w-percent">
        <ion-label class="fs-pt-16"><b>{{modalMessagePasta | uppercase}}</b></ion-label>
      </div>
      <div class="flex fx-column ion-padding full-w-percent">
        <ion-button class="full-w-percent ion-margin-top ion-text-uppercase"
          color="primary" (click)="confirmPasta()" fill="solid"
        expand="block">{{confirmButtonText | uppercase}}</ion-button>
        <ion-button class="full-w-percent ion-margin-top ion-text-uppercase"
          color="danger" (click)="cancel()" fill="solid"
        expand="block">{{cancelButtonText | uppercase}}</ion-button>
      </div>
    </div>
  }
  <!---------- ENDMARK: PASTA IN BIANCO --------------->

  <!---------- MARK: ASSENZA --------------->
  @if (currentSegment === visualizzazione.ASSENZA_STUDENTE) {
    <div [style.height]="'85%'"
      class="flex fx-column ion-justify-content-between ion-padding-horizontal full-w-percent overflow-y">
      <div class="flex fx-column ion-justify-content-center ion-padding">
        <div class="ion-padding-bottom ion-text-center">
          <ion-label class="fs-pt-16" color="primary"><b>{{messageDateAssenza | uppercase}}</b></ion-label>
        </div>
        <div class="flex fx-column full-w-percent ion-justify-content-center ion-align-items-center margin-top-25px">
          <ion-label><b>DAL GIORNO:</b></ion-label>
          <!-- <ion-datetime presentation="date" [min]="todayDate" [multiple]="false" [value]="currentDate"
          [formControl]="ctrlAssenzaInizio">
        </ion-datetime>-->
        <ion-item id="date">
          <ion-input [value]="ctrlAssenzaInizio.value | date: 'dd/MM/yyyy'" readonly="true"
          class="ion-text-center ion-padding-start ion-margin-start"
          aria-label="Dal giorno"></ion-input>
          <ion-icon name="calendar-outline"></ion-icon>
          <ion-modal trigger="date" [keepContentsMounted]="true" id="date-modal" class="custom-ion-modal"
            [backdropDismiss]="false" aria-label="Seleziona data inizio">
            <ng-template>
              <ion-datetime presentation="date" class="custom-datetime" #firstdatetime
                [showDefaultButtons]="true"
                [min]="todayDate" [multiple]="false" [value]="currentDate"
                [formControl]="ctrlAssenzaInizio">
                <ion-buttons slot="buttons">
                  <ion-button [style.width]="'36%'" class="font-size-16px" fill="solid" color="danger" (click)="firstdatetime.cancel(); closeModal()">ANNULLA</ion-button>
                  <ion-button [style.width]="'36%'" class="font-size-16px" fill="solid" color="primary" (click)="firstdatetime.confirm(); closeModal()">CONFERMA</ion-button>
                </ion-buttons>
              </ion-datetime>
            </ng-template>
          </ion-modal>
        </ion-item>
      </div>
      <div class="flex fx-column full-w-percent ion-justify-content-center ion-align-items-center ion-margin-top">
        <ion-label><b>AL GIORNO:</b></ion-label>
        <!--<ion-datetime presentation="date" [min]="todayDate" [multiple]="false" [value]="currentDate"
        [formControl]="ctrlAssenzaFine">
      </ion-datetime>-->
      <ion-item id="date2">
        <ion-input [value]="ctrlAssenzaFine.value | date: 'dd/MM/yyyy'" readonly="true"
        class="ion-text-center ion-padding-start ion-margin-start"
        aria-label="Al giorno"></ion-input>
        <ion-icon name="calendar-outline"></ion-icon>
        <ion-modal trigger="date2" [keepContentsMounted]="true" id="date-modal2" class="custom-ion-modal"
          [backdropDismiss]="false" aria-label="Seleziona data fine">
          <ng-template>
            <ion-datetime presentation="date2" class="custom-datetime"  #seconddatetime
              [showDefaultButtons]="true"
              [min]="todayDate" [multiple]="false" [value]="currentDate"
              [formControl]="ctrlAssenzaFine"
              >
              <ion-buttons slot="buttons">
                <ion-button [style.width]="'36%'" class="font-size-16px" fill="solid" color="danger" (click)="seconddatetime.cancel(); closeModal()">ANNULLA</ion-button>
                <ion-button [style.width]="'36%'" class="font-size-16px" fill="solid" color="primary" (click)="seconddatetime.confirm(); closeModal()">CONFERMA</ion-button>
              </ion-buttons>
            </ion-datetime>
          </ng-template>
        </ion-modal>
      </ion-item>
    </div>
  </div>
  <div class="flex fx-column ion-padding full-w-percent">
    <ion-button class="ion-margin-top ion-text-uppercase"
      color="primary" (click)="confirmAssenza()" fill="solid"
    expand="block">{{confirmButtonText | uppercase}}</ion-button>
    <ion-button class="ion-margin-top ion-text-uppercase"
      color="danger" (click)="cancel()" fill="solid"
    expand="block">{{cancelButtonText | uppercase}}</ion-button>
  </div>
</div>
}
<!---------- ENDMARK: ASSENZA --------------->

</div>

